// extracted by mini-css-extract-plugin
export var label = "keyValue-module--label--d6434";
export var svgWrapper = "keyValue-module--svgWrapper--e1058";
export var value = "keyValue-module--value--9af90";